import gql from 'graphql-tag';

export const getPollingAnswers = gql`
  query ($pollingQuestion: Int) {
    getPollingAnswers(pollingQuestion: $pollingQuestion) {
      pollingAnswerId
      choices
      openText
      rating
      pollingToken {
        referralId
        views
        pollingDate
      }
    }
  }
`
